// Description: Info of the finish sign up form
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// Components and Functions for the project
import CheckIcon from '../../../components/Pricing/CheckIcon';

// Render The Component
export default function Info({ selected_plan }) {
    return (
        <>
            <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                Total
            </Typography>
            <Typography variant="h4" gutterBottom>
                {Number(selected_plan?.price).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                })}
            </Typography>
            <List disablePadding>
                <ListItemText
                    sx={{ mr: 2 }}
                    primary={
                        <span style={{ fontSize: '1rem' }}>
                            {selected_plan?.name}
                        </span>
                    }
                    secondary="Recursos incluídos"
                />
                {selected_plan?.features.map((feature, index) => (
                    <ListItem key={index} sx={{ py: 0.8, px: 0 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: '12px' }}>
                            <CheckIcon have={true} />
                            <Typography variant="body2" sx={{ ml: 1 }}>
                                {feature}
                            </Typography>
                        </Box>
                    </ListItem>
                ))}
            </List>
        </>
    );
}
